import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { RestApi } from '@node-space/rest-api'
import { Box, Button, Checkbox, Dialog } from '@node-space/ui-components'
import General, { PathNames } from 'constants/General'
import { WithdrawActionProps } from './Withdraw'

const Withdraw2fa = ({ setStep, dismissAction }: WithdrawActionProps) => {
  const { t } = useTranslation()
  const [ignore2fa, setIgnore2fa] = useState<boolean>(false)
  const navigate = useNavigate()

  const setIgnore2faWarning = () => {
    // 60 days
    RestApi.setCookie(General.IGNORE_2FA_COOKIE_NAME, '1', 60)
  }

  return (
    <Dialog
      title={t('2FAWithdrawalNotice')}
      open
      onClose={dismissAction}
      type="utility"
      ActionButtons={[
        <Button
          key="2FAContinue"
          testId={t('2FAContinue')}
          onClick={() => {
            ignore2fa && setIgnore2faWarning()
            setStep('form')
          }}
        >
          {t('2FAContinue')}
        </Button>,
        <Button
          key="2FAEnable"
          variant="secondary"
          onClick={() => {
            ignore2fa && setIgnore2faWarning()
            navigate(`${PathNames.SETTINGS}${PathNames.MANAGE_USER_PROFILE}`)
          }}
        >
          {t('2FAEnable')}
        </Button>,
      ]}
    >
      <Box flexCol gap={16} data-testid="withdraw2fa">
        <p className="text-foreground-prominent text-body-regular">{t('2FAMessage')}</p>
        <p className="text-foreground-prominent text-body-regular">{t('2FAMessageSettings')}</p>
        <Checkbox
          id="withdraw2fa-checkbox"
          name="withdraw2fa-checkbox"
          testId="withdraw2fa-checkbox"
          label={t('2FAAskAgain')}
          checked={ignore2fa}
          onCheckedChange={value => setIgnore2fa(value as boolean)}
        />
      </Box>
    </Dialog>
  )
}

export default Withdraw2fa
